import { ReactNode } from 'react';
import styled from 'styled-components';

import { H3 } from 'components/Text/H3';
import { Tile, TileBody } from 'components/Tile';

const StyledTile = styled(Tile)`
  &[id] {
    scroll-margin-top: calc(83px + 36px);
  }

  margin-bottom: 36px;
  &:not(:first-child) {
    margin: 36px 0;
  }
`;
const StyledTileBody = styled(TileBody)`
  & > *:last-child {
    margin-bottom: 0;
  }
`;

type Props = {
  id?: string;
  className?: string;
  title?: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  large?: boolean;
  bodyPaddingBottom?: (string | number | null)[];
};

export function FormSection({
  id,
  className,
  title,
  description,
  children,
  large,
  bodyPaddingBottom,
  ...props
}: Props) {
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledTile id={id} className={className} {...props}>
      <StyledTileBody
        p={large ? [48, null, 96] : [20, null, 40]}
        pt={large && [36, null, 64]}
        pb={bodyPaddingBottom}
      >
        {title && <H3 mb={large && !description ? 56 : undefined}>{title}</H3>}

        {description && (
          <div style={{ marginBottom: large ? 56 : undefined }}>
            {description}
          </div>
        )}

        {children}
      </StyledTileBody>
    </StyledTile>
  );
}
